import { GAME_DEF_FORM } from '_constants';

export default number => ({
  ...GAME_DEF_FORM.DEFAULT_QUESTION,
  number,
  answers: new Array(1) // you can change count of answers by default in question
    .fill({ ...GAME_DEF_FORM.DEFAULT_ANSWER })
    .map((answer, idx) => (idx === 0 ? { ...answer, is_correct: true } : answer)),
});
